//// NOTE: keep alphabetical order in properties sorting

export const ValidationMessages = {
  analytics: {
    profiles: {
      required: {
        overview: 'Select at least 1 profile',
        perProfile: 'Select 1 profile'
      }
    }
  },
  autoImport: {
    import: {
      required: 'Please select where to import the posts'
    },
    modify: {
      required: 'Please provide at least a prefix or suffix'
    },
    name: {
      maxLength: 'This name is too long'
    },
    profiles: {
      noProfile: 'Please select at least one Social Profile.',
      pinBoard: 'Please select a Board.',
      wrongValue: 'Value type on profiles is incorrect. Please try reselecting profiles.'
    },
    refine: {
      required: 'Please provide a search team'
    },
    saveOption: {
      required: 'Please select a save option'
    },
    url: {
      required: 'PLease provide a valid url'
    }
  },
  calendar: {
    required: 'Pick a date'
  },
  categories: {
    name: {
      required: 'Please give this Category a name',
      maxLength: 'Category name cannot exceed 50 characters'
    }
  },
  categoriesSelect: {
    required: 'Please select a category.'
  },
  categoriesSocialProfiles: {
    required: 'Please select at least one Social Profile.'
  },
  checkbox: {
    required: 'This option is required.'
  },
  category: {
    required: 'Category option is required.'
  },
  colorPicker: {
    required: 'A category colour is required.'
  },
  discover: {
    rssUrl: {
      required: 'A valid RSS URL is required'
    },
    source: {
      name: {
        maxLength: 'This name is too long.'
      }
    }
  },
  media: {
    addByUrl: {
      required: 'A valid image URL is required'
    }
  },
  email: {
    invalid: 'You need to provide a valid email.',
    required: 'Email is required.'
  },
  facebookGroupsPostAs: {
    required: 'Please select a user to post.'
  },
  name: {
    invalid: 'Please enter a valid name.',
    required: 'Please enter a valid name.'
  },
  password: {
    invalid: 'Password must be at least 8 characters long.',
    required: 'Password is required.'
  },
  repeatPassword: {
    invalid: "Passwords don't match!"
  },
  select: {
    required: 'Please select an option.'
  },
  snippetsName: {
    required: 'Please enter a name',
    maxLength: 'Max 50 characters'
  },
  snippetsContent: {
    required: 'Please add some text for this Snippet.',
    hashtagAndMaxLength: 'Max 2200 characters or 30 hashtags.'
  },
  socialAuthToken: {
    required: ''
  },
  socialProfiles: {
    required: 'Please select at least one Profile to connect.',
    categories: {
      required: 'Please select at least one Social Profile'
    },
    pinterestBoard: {
      required: 'Please select a Board.'
    },
    select: {
      required: 'Please select at least one Profile.'
    }
  },
  timezone: {
    required: ''
  },
  token: {
    required: ''
  },
  tos: {
    required: 'Please accept our Terms & Service to continue.'
  },
  workspace: {
    name: {
      required: 'Name is required.',
      maxLength: 'This name exceed maxLength.',
      minLength: 'This name does not meet the minLength.'
    }
  }
};
